import React from 'react';
import PropTypes from 'prop-types';
import Check from '../common/Check/Check';

export default function WaitingStep({ component, isCheck }) {
  return (
    <div className="waitingStep">
      <div className={isCheck ? 'animatedStep' : ''}>
        {isCheck && (
        <div className="op">
          <Check />
        </div>
        )}
        <div className="op active">{component()}</div>
      </div>
    </div>
  );
}

WaitingStep.propTypes = {
  /**
   * {
   *  "info": "Función que retorna el icono con la label que se ha de pintar",
   *  "kind": "both",
   *  "beautifulName": "icono de waiting page"
   * }
   */
  component: PropTypes.func.isRequired,
};
